<template>
    <oc-select-input v-bind="$attrs" :selected="value" :placeholder="placeholder">
        <template #default="{selected}">
            <slot :selected="selected"></slot>
        </template>

        <template #empty-option>
            <slot name="empty-option"></slot>
        </template>
    </oc-select-input>
</template>

<script>
export default {
    name: 'oc-select2',
    props: {
        value: {
            type: [String, Number, Array]
        },
        placeholder: {
            type: String,
            default: '(not set)'
        },
        pluginOptions: {
            type: Object,
            default: () => ({})
        }
    },
    mounted() {
        var vm = this

        $(this.$el)
            // init select2
            .select2(this.$_pluginOptions)

            // emit event on change.
            .on('select2:close', function() {

                let newValue = $(vm.$el).select2('val')

                let currentValue = vm.value

                if( toJson(currentValue) === toJson(newValue) ) {
                    return
                }

                vm.$emit('input', newValue)
            })
    },
    computed: {
        $_pluginOptions() {
            return Object.assign(
                {
                    width: '100%',
                    theme: 'bootstrap4',
                    placeholder: this.placeholder,
                    allowClear: true
                },
                this.pluginOptions
            )
        }
    },
    watch: {
        value(newVal) {
            // update options
            $(this.$el).val(newVal).trigger('change')
        },
        pluginOptions(newOptions) {
            // update options
            $(this.$el).select2(this.$_pluginOptions)
        }
    },
    destroyed() {
        $(this.$el).off().select2('destroy')
    }
}
</script>

<style>
select.is-invalid~.select2-container--bootstrap4 .select2-selection,
form.was-validated select:invalid~.select2-container--bootstrap4 .select2-selection {
    border-color: #dc3545;
}

select.is-valid~.select2-container--bootstrap4 .select2-selection,
form.was-validated select:valid~.select2-container--bootstrap4 .select2-selection {
    border-color: #28a745;
}

.select2-container--bootstrap4.select2-container--focus .select2-selection {
    box-shadow: none;
}

.select2-container--bootstrap4 .select2-selection--single .select2-selection__rendered,
.select2-container--bootstrap4 .select2-selection--single .select2-selection__placeholder {
    font-weight: normal;
}
</style>
